import { TooltipProps } from 'recharts/types/component/Tooltip.js'

import { Card } from '@tribeplatform/react-ui-kit/Card'

import { analyticsNumberFormatter } from '../utils/parser.js'

interface CustomToolTipRechartsHOCProps {
  labels: string[]
}
export const CustomToolTipRechartsHOC = ({
  labels,
}: CustomToolTipRechartsHOCProps) => {
  return ({ payload, label, active }: TooltipProps<number, string>) => (
    <CustomToolTipRecharts
      payload={payload}
      label={label}
      active={active}
      labels={labels}
    />
  )
}

interface CustomToolTipRechartsProps extends TooltipProps<number, string> {
  labels: string[]
}
const CustomToolTipRecharts = ({
  payload,
  label,
  labels,
  active,
}: CustomToolTipRechartsProps) => {
  const calculateSum = () => {
    return payload.reduce((sum, { value }) => {
      return sum + value
    }, 0)
  }
  return (
    <>
      {active && payload?.length && (
        <Card className="p-4">
          <>
            <div className="text-sm text-content text-center">{label}</div>
            {payload.length > 1 && (
              <div className="text-sm text-content-subdued text-center">
                {calculateSum()}
              </div>
            )}
            {payload.map(({ color, dataKey, value }, index) => (
              <div className="flex items-center space-s-2 mt-1" key={dataKey}>
                <div
                  style={{ backgroundColor: color }}
                  className="w-3 h-3 rounded-sm"
                ></div>
                <div className="text-sm">
                  <span className="text-content-subdued">
                    {/* eslint-disable-next-line react/jsx-no-literals */}
                    {labels[index]}:{' '}
                  </span>
                  <span style={{ color }}>
                    {analyticsNumberFormatter(value)}
                  </span>
                </div>
              </div>
            ))}
          </>
        </Card>
      )}
    </>
  )
}
